<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <LockClosedIcon class="text-white w-12 h-12 mb-3" />
    <p class="text-white text-center font-bold text-xl mb-7">
      Unfortunately you can not access the consultation
    </p>

    <!-- <p class="text-white text-center font-bold text-3xl mb-7">{{ formatedDuration }}</p> -->

    <div class="details">
      <p class="text-white text-center font-bold mb-7">
        Only the attendees that were present during the introduction phase will be able to join the
        consultation
      </p>
      <p class="text-white text-center mb-7">
        You can still join the debrief of the session once the consultation ends. The button below
        will become active once the debrief begins.
      </p>
    </div>

    <ViceButton :disabled="!canJoin" dark icon="ShieldCheckIcon" @click="joinDebrief">
      Join debrief
    </ViceButton>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { LockClosedIcon } from '@heroicons/vue/outline';
import ViceButton from '../../Buttons/ViceButton.vue';

export default {
  name: 'SessionOnHoldNotification',
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  components: {
    ViceButton,
    LockClosedIcon,
  },

  setup() {
    const canJoin = ref(false);
    onMounted(() => {
      setTimeout(() => {
        window.Echo.private(`session-state-changed`).listen(
          '.session.state.changed',
          (stateChanges) => {
            if (
              stateChanges.phase === 'debrief' ||
              (stateChanges.phase === 'consultation' && stateChanges.state === 'ended')
            )
              canJoin.value = true;
          },
        );
      }, 1000);
    });

    const joinDebrief = () => {
      window.location.reload();
    };

    return {
      joinDebrief,
      canJoin,
    };
  },
};
</script>

<style scoped>
.details {
  max-width: 415px;
}
</style>
